import BasePart from './BasePart'

class StereoPan extends BasePart
  constructor: (audioContext, { value = 0, destination }) ->
    super(audioContext, { destination })
    @instanceNode = @_createInstance()
    @setValue(value)
    @connect(destination)

  _createInstance: ->
    @setInterface(@audioContext.createStereoPanner())

  setInterface: (destination) ->
    @interface = destination

  getInterface: ->
    @interface

  getInstance: ->
    @instanceNode

  setValue: (value) ->
    @getInstance().pan.value = value

  getValue: ->
    @getInstance().pan.value

export default StereoPan
